import { Request } from "shared/src/services/Requests";

const RequestBuilder = new Request.Builder("searchdiscover", "store-location", true);

export type StoreByLocationResult = {
    storeNumber: string;
};

export function determineClosestStoreByLocation(
    country: string,
    long: number | undefined,
    lat: number | undefined
): Promise<StoreByLocationResult> {
    const url = `/countries/${country}/closest-store`;
    return RequestBuilder.path(url, {}).query({ latitude: lat, longitude: long }).get();
}
